import { render } from "./BookDetail.vue?vue&type=template&id=a1ce3b20&scoped=true&bindings={}"
import script from "./BookDetail.vue?vue&type=script&lang=ts"
export * from "./BookDetail.vue?vue&type=script&lang=ts"

import "./BookDetail.vue?vue&type=style&index=0&id=a1ce3b20&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-a1ce3b20"

export default script